import apiService from './ApiService';

const MENSAJERIA_PWA_KEY = 'mensajeria-pwa';
const FAMILIA_PWA_KEY = 'familia-pwa';

export const PWA_APP_OPTIONS = [
  {
    key: MENSAJERIA_PWA_KEY,
    label: 'Mensajes',
    title: 'Aluxia Mensajes',
    defaultMessage: 'Se solicita actualizar Aluxia Mensajes. Al aceptar, la app se recargará para aplicar los cambios.'
  },
  {
    key: FAMILIA_PWA_KEY,
    label: 'Familia',
    title: 'Aluxia Familia',
    defaultMessage: 'Se solicita actualizar Aluxia Familia. Al aceptar, la app se recargará para aplicar los cambios.'
  }
];

export const getPwaAppOption = (appKey) =>
  PWA_APP_OPTIONS.find((option) => option.key === appKey) || PWA_APP_OPTIONS[0];

const pad2 = (value) => String(value).padStart(2, '0');

const buildAutoUpdateVersion = () => {
  const now = new Date();
  return [
    now.getFullYear(),
    pad2(now.getMonth() + 1),
    pad2(now.getDate())
  ].join('.') + `.${pad2(now.getHours())}${pad2(now.getMinutes())}${pad2(now.getSeconds())}`;
};

class PwaAppsService {
  async getVersion(appKey = MENSAJERIA_PWA_KEY, currentVersion = '') {
    const params = new URLSearchParams();
    if (currentVersion) {
      params.set('currentVersion', currentVersion);
    }

    const qs = params.toString();
    return apiService.get(`/pwa-apps/${appKey}/version${qs ? `?${qs}` : ''}`);
  }

  async updateVersion(appKey = MENSAJERIA_PWA_KEY, { version, requiereActualizacion, mensaje }) {
    const updateVersion = version || buildAutoUpdateVersion();

    return apiService.put(`/pwa-apps/${appKey}/version`, {
      version: updateVersion,
      requiereActualizacion,
      mensaje,
      notificarUsuarios: true
    });
  }

  async getMensajeriaVersion(currentVersion = '') {
    return this.getVersion(MENSAJERIA_PWA_KEY, currentVersion);
  }

  async updateMensajeriaVersion({ version, requiereActualizacion, mensaje }) {
    return this.updateVersion(MENSAJERIA_PWA_KEY, { version, requiereActualizacion, mensaje });
  }
}

const pwaAppsService = new PwaAppsService();

export default pwaAppsService;
